import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页', end: true },
  { to: '/category', label: '全部漫画', end: false },
  { to: '/about', label: '关于我们', end: false },
];

export default function Navbar() {
  const [keyword, setKeyword] = useState('');
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    navigate(kw ? `/category?q=${encodeURIComponent(kw)}` : '/category');
    setOpen(false);
  };

  return (
    <header>
      <div className="bg-primary-500 text-background-50">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-center gap-x-2 gap-y-0.5 px-4 py-1.5 text-xs">
          <i className="ri-flashlight-fill text-sm"></i>
          <span className="whitespace-nowrap">
            全站漫画在线免费阅读 · 每日更新 · 无需注册即可畅读
          </span>
        </div>
      </div>

      <div className="sticky top-0 z-50 border-b border-background-200 bg-background-50/95 backdrop-blur">
        <div className="mx-auto flex h-16 max-w-7xl items-center justify-between gap-4 px-4 md:px-6">
          <Link
            to="/"
            className="flex shrink-0 items-center gap-2"
            aria-label="布丁漫画网首页"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-background-50">
              <i className="ri-book-open-fill text-lg"></i>
            </span>
            <span className="font-heading text-2xl leading-none text-foreground-950">
              布丁漫画网
            </span>
          </Link>

          <nav
            className="hidden items-center gap-1 md:flex"
            aria-label="主导航"
          >
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                    isActive
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-100 hover:text-primary-600'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="hidden flex-1 justify-end md:flex">
            <form
              onSubmit={handleSearch}
              role="search"
              className="flex w-72 max-w-full items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2 transition-colors focus-within:border-primary-300"
            >
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画名称"
                aria-label="搜索漫画"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </form>
          </div>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md text-xl text-foreground-800 hover:bg-background-100 md:hidden"
            aria-label={open ? '关闭菜单' : '打开菜单'}
            aria-expanded={open}
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>

        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
            <form onSubmit={handleSearch} role="search" className="mb-3 flex items-center gap-2 rounded-full border border-background-200 bg-background-100 px-4 py-2">
              <i className="ri-search-line text-sm text-foreground-500"></i>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索漫画名称"
                aria-label="搜索漫画"
                className="w-full bg-transparent text-sm text-foreground-800 outline-none placeholder:text-foreground-400"
              />
            </form>
            <nav className="flex flex-col gap-1" aria-label="移动端导航">
              {navItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.end}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    `rounded-md px-3 py-2.5 text-sm font-medium ${
                      isActive
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-foreground-700 hover:bg-background-100'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}